const config = {
  BASE_URL: "http://enlitebackend.enlite.lk",
};

export default config;

//BASE_URL: "https://colkanpos-b-production.up.railway.app",